import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

import { BaseHttpService } from './base-http.service';
import {FMLayout,FMIssueList, FMGeneralRequestModel, PaginationModel, PagedResult, FMAllRequestsModel, CompanyBuildingUnitView, FMSpecialRequestModel, FMRegisterHazardMaterial, MaterialFile, FMDeliveryRequestModel, RequestVenue, EventRequestModel, RequestGeneral } from '../models';
import { FMRequestHazardMaterial, AnnouncementRequestsModel } from '@app/core';

@Injectable()
export class DashboardService extends BaseHttpService<any> {

  constructor(private http: HttpClient) {
    super('dashboard');
  }

  getDashboardRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<FMAllRequestsModel>> {
    return this.http
      .get(this.getApiURI() + '/dashboard/GetDashboardRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getPushedAnnouncements(): Observable<AnnouncementRequestsModel[]> {
    return this.http
      .get(this.getApiURI() + "/dashboard/GetPushedAnnouncements")
      .catch(this.handleError)
  }
  addFeedbackFunction(requestId: number, comments: string): Observable<string> {

    return this.http
      .put(this.getApiURI() + `/dashboard/${requestId}/add-feedback`, { comments: comments })
      .catch(this.handleError)

  }
  getUpcomingMeetings(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<RequestVenue>> {
    return this.http
      .get(this.getApiURI() + '/dashboard/GetUpcomingMeetings' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getUpcomingEvents(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<EventRequestModel>> {
    return this.http
      .get(this.getApiURI() + '/dashboard/GetUpcomingEvents' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  getAllRequests(): Observable<RequestGeneral[]> {
    return this.http
      .get(this.getApiURI() + '/dashboard/GetAllRequests' )
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/dashboard.service.ts